import es from './es/messages';
import en from './en/messages';
import fr from './fr/messages';
import ay from './ay/messages';

export default {
  es,
  en,
  fr,
  ay
};



// WEBPACK FOOTER //
// ./src/lang/index.js